import { StudyStatus } from "../../shared-new/enums/study-status.enum";
import { SaleHorse } from "../sales/sale-horse.model";
import { SaleMemberRequests } from "../sales/sale-member-request.model";
import { SaleSubmissions } from "../sales/sales.model";
import { StudyFileDownloadStatusDto } from "../Study/study.model";

export class NotificationEventTypeAction {
  public static SaleAccess: string = 'SaleAccess';
  public static SaleResult: string = 'SaleResult';
  public static StudySubmitted: string = 'StudySubmitted';
  public static DownloadStatusUpdate: string = 'DownloadStatusUpdate';
  public static DownloadComplete: string = 'DownloadComplete';
  public static DownloadError: string = 'DownloadError';
  public static DownloadCancelled: string = 'DownloadCancelled';

}

export interface NotificationEvent<T> {
  eventType: NotificationEventType;
  entityType: NotificationEntityType;
  action: NotificationAction;

  scope: EventScope;
  notificationAlert: NotificationAlert;

  data: T;              // payload
  occurredAt: string;   // ISO string from backend (DateTime.UtcNow)
  read: boolean;
  notificationId: number;
}

export interface EventScope {
  saleId: number;
  saleIds: number[];
  horseId?: number | null;
  studyId?: number | null;
  studyFileId?: number | null;
  memberId?: number | null;
  userId?: number | null;
}

export interface NotificationAlert {
  notifyUser: boolean;
  message?: string | null;
  description?: string | null;
  title?: string | null;
  type: NotificationAlertType;
}


export enum NotificationEventType {
  SaleAccess = 1,
  StudySubmitted = 2,
  SaleResult = 3,
  DownloadStatusUpdate = 4
}

export enum NotificationEntityType {
  Sales = 1,
  Study = 2,
  Member = 3
}

export enum NotificationAction {
  Created = 1,
  Updated = 2,
  Submitted = 3,
  Approved = 4,
  Denied = 5,
  Requested = 6,
  Completed = 7,
  Cancelled = 8
}

export enum NotificationAlertType {
  Info = 1,
  Success = 2,
  Warning = 3,
  Error = 4
}

export interface StudySubmittedNotificationDto {
  saleId: number;
  horseId: number;
  salesCompanyUserId: number;
  saleName: string;
  submittedBy: string;
  lotNumber: string;
  status: StudyStatus;
  saleHorse: SaleHorse;
  submissions: SaleSubmissions[];
}

export interface SaleRequestNotificationDto {
  saleId: number;
  salesCompanyUserId: number;
  saleName: string;
  requestedBy: string;
  saleMemberRequest: SaleMemberRequests;
}

export interface SaleResultUpdateDto {
  saleId: number;
  horseId: number;
  saleName: string;
  horseName: string;
  saleResult: string;
  saleHorse: SaleHorse;
}

export interface DownloadStatusNotificationDto {
  saleId: number;
  saleName: string;
  userId: number;
  userIds: number[];
  downloadStatus: StudyFileDownloadStatusDto[];
  isCompleted: boolean;
  isCancelled: boolean;
  isError: boolean;
  message: string;
}
